import { Component } from "../extends";
import Card from "./Card/index";

export default (ctx) =>
	class Cards extends Component(ctx) {
		mounted() {
			this.cards = this.initCards();
		}

		initCards() {
			const els = this.el.querySelectorAll(".c-card.js-card") || [];

			return [...els].map(
				(el, index) =>
					new (Card(ctx))(el, {
						index,
						toggleCb: (params) => this.toggle(params),
					})
			);
		}

		toggle({ index }) {
			const currentCard = this.cards[index - 1];

			this.cards.forEach((card) => {
				if (
					card.index !== index &&
					card.el.classList.contains("is-open")
				) {
					card.disable();
				}
			});

			if (!currentCard.el.classList.contains("is-open")) {
				currentCard.enable();
			} else {
				currentCard.disable();
			}
		}
	};
